<template>
  <div :style="customStyle">
    <div v-for="filter in filters" :key="filter.key">
      <div v-if="showLabel" class="sac__font-16 semi-bold">
        <span>{{ filter.label }}</span>
      </div>
      <SACFilterOption
        :key="filter.key"
        :item="filter"
        :change="updateFilter"
        :clear="clear"
        :loading="loading"
        :maxWidth="maxWidth"
        :ellipsis="ellipsis"
        :dark="dark"
      />
    </div>
  </div>
</template>

<script>
import SACFilterOption from './SACFilterOption.vue';

export default {
  name: 'SACFilters',
  components: {
    SACFilterOption,
  },
  props: {
    loading: Boolean,
    filters: {
      type: Array,
      default() {
        return [];
      },
    },
    showLabel: Boolean,
    dark: Boolean,
    change: Function,
    clear: Function,
    width: {
      type: String,
      default: '100%',
    },
    maxWidth: {
      type: String,
      default: 'auto',
    },
    ellipsis: {
      type: String,
      default: '',
    },
  },
  computed: {
    customStyle() {
      return {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '10px',
        fontSize: '0.85em',
        flex: 1,
      };
    },
  },
  methods: {
    updateFilter(option, key) {
      const newFilters = this.filters.map((op) => {
        const newOp = { ...op };
        if (newOp.key === key) {
          newOp.active = true;
          if (Array.isArray(newOp.activeOption)) {
            if (!newOp.activeOption.includes(option)) {
              newOp.activeOption.push(option);
            }
          } else {
            newOp.activeOption = option;
          }
        }
        return newOp;
      });
      this.change(newFilters, key);
    },
  },
};
</script>
